/**Модель описывающая сортировку задач */
export class TaskSortingModel {
  /**Сортировка по ID */
  OrderById: boolean | undefined;
  /**Сортировка по имени */
  OrderByName: boolean | undefined;
  /**Сортировка по оценочному времени */
  OrderByEstimateTime: boolean | undefined;
  /**Сортировка по затраченному времени */
  OrderByWorkTime: boolean | undefined;
  /**Сортировка по сложности */
  OrderByDifficulty: boolean | undefined;
  /**Сортировка по очереди */
  OrderByQueue: boolean | undefined;
  /**Сортировка по статусу */
  OrderByStatus: boolean | undefined;
  /**Сортировка по приоритету */
  OrderByPriority: boolean | undefined;

  constructor(obj?: Partial<TaskSortingModel>) {
    Object.assign(this, obj);
  }
}
